module.exports = __webpack_public_path__ + "static/media/loading.f8222d07.gif";